import { useTranslation } from 'react-i18next';
import { AlertCircle } from 'lucide-react';
import { Alert, AlertDescription } from '@bliks-io/ui';

interface DraftErrorAlertProps {
  submitError?: string;
  invalidRowCount: number;
}

/**
 * The one destructive banner every wizard draft step shows above its table: a
 * generic "fix the highlighted rows" line, the server's submit error when
 * present, and the count of client-invalid rows. Renders nothing when the step
 * is clean.
 */
export function DraftErrorAlert({ submitError, invalidRowCount }: DraftErrorAlertProps) {
  const { t } = useTranslation();
  if (!submitError && invalidRowCount === 0) return null;
  return (
    <Alert variant="destructive">
      <AlertCircle className="h-4 w-4" />
      <AlertDescription>
        <div className="space-y-2">
          <p>{t('initialSetup.upload.errorBanner')}</p>
          {submitError && <p className="text-sm font-medium">{submitError}</p>}
          {invalidRowCount > 0 && (
            <p className="text-sm">
              {t('initialSetup.upload.invalidRowsCount', { count: invalidRowCount })}
            </p>
          )}
        </div>
      </AlertDescription>
    </Alert>
  );
}
